import script from "./ml-button.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-button.vue?vue&type=script&setup=true&lang=js"

import "./ml-button.vue?vue&type=style&index=0&id=4a780315&lang=scss"

const __exports__ = script;

export default __exports__